import EventDispatcher from '../events/EventDispatcher';

import {ALIGN, VALIGN} from '../globals';
import * as FEATURES from './features';

import {bindEvent, unbindEvent, preventEvent, getPointerCoordinates} from './helpers.js';

import {P2L} from './images';

let WINDOW_IS_HIDDEN = false;

let fitLayoutTimer = null;

let staticWindowRect = null; // TODO: refactor this

/**
 * Ориентация устройства
 * @memberOf module:layout.DOMLayout
 * @type {{LANDSCAPE: number, PORTRAIT: number}}
 * @property {Number} LANDSCAPE ладншафная
 * @property {Number} PORTRAIT портретная
 * @constant
 */
const ORIENTATION = {LANDSCAPE: "landscape", PORTRAIT: "portrait"};

/** @ignore */
function mobileHideAddressBar() { // TODO: configurable on/off
    window.scrollTo(0, 0);
}

class CanvasLayer {

    static create(container) {
        let canvas = container.appendChild(document.createElement('canvas'));
        canvas.className = 'p2m-screen';
        canvas.style.position = 'absolute';
        return new CanvasLayer(canvas);
    }

    constructor(canvas) {
        this.canvas = canvas;
    }
}

var SCALE = 1;

/**
 * @class
 * @inheritDoc
 * @extends EventDispatcher
 * @memberOf module:layout
 * @classdesc Основной класс для манипуляции окружением DOM
 */
class DOMLayout extends EventDispatcher {

    /**
     * @constructor
     * @param {HTMLElement} container
     * @param {{width:number, height:number}} size
     * @param {boolean} autoCheckOrientation
     */
    constructor(container, size = {width: 960, height: 640}, noCheckOrientation=false) {

        super();

        this.size = size;
        this.noCheckOrientation = !!noCheckOrientation;

        /** @ignore */
        this.calculatedSize = {
            width: size.width,
            height: size.height,
            screenWidth: size.width,
            screenHeight: size.height,
            scale: 1
        };

        /** @ignore */
        this.bitmapScale = 1;

        /**
         * Кешированное значение orientation
         * @private
         */
        this._lastOrientation = null;

        /**
         * Кешированное значение viewport
         * @type {{width: number, height: number}}
         * @private
         */
        this._lastViewport = {width: null, height: null};

        /**
         * Выравнивание в контейнере
         * @type {{horizontal: string, vertical: string}}
         */
        this.align = {
            horizontal: ALIGN.CENTER,
            vertical: VALIGN.MIDDLE
        };

        /**
         * Отступы. Массив чисел (правила аналогичны CSS) или число
         * @type {number[]}
         */
        this.margin = [0, 0, 0, 0];

        /**
         * Массив из HTMLCanvasElement для рендеринга приложения
         * @type {Map}
         */
        this.screens = [];

        container = ((container instanceof HTMLElement) && container) || document.querySelector(container);
        if (!(container instanceof HTMLElement)) {
            throw new Error('Invalid layout container');
        }

        if (container.parentNode === document.body) {
            container.parentNode.style.overflow = 'hidden';
        }

        /**
         * Основной контейнер, в котором содержится приложение
         * @type {HTMLElement}
         */
        this.container = container;
        this.container.className = 'p2m-layout';
        Object.assign(this.container.style, {
            position: 'absolute',
            overflow: 'hidden'
        });

        this.addLayers('screens', 'preloader', 'p2l');
        this.initP2L({
            css: {
                display: 'none'
            }
        });

        // Hack for wrong window size reported by browser
        this._domMarkElement = null;
        if (window.parent == window && FEATURES.ANDROID && FEATURES.FIREFOX) {
            this._domMarkElement = this.container.appendChild(document.createElement("div"));
            Object.assign(this._domMarkElement.style, {
                position: "fixed",
                right: "0px",
                bottom: "0px",
                width: "2px",
                height: "2px",
                background: "transparent",
                zIndex: "100000"
            });
        }

        this.fitLayout(true);
        this.autoFit = true;

        this._autoFill = false;

        return this;
    }

    get autoFill() {
        return this._autoFill;
    }

    set autoFill(val) {
        this._autoFill = !!val;
        this.fitLayout(true);
    }

    /**
     * @member {boolean} module:layout.DOMLayout~windowVisible Флаг, указывающий видно ли окно, в котором создан layout
     * @readonly
     */
    get windowVisible() {
        return !WINDOW_IS_HIDDEN;
    }

    /**
     * Масштаб для подгонки размеров приложения
     * @alias DOMLayout~scale
     * @type {number}
     */
    get scale() {
        return SCALE;
    }

    //noinspection JSAnnotator
    set scale(val) { // TODO: apply scale, useful for manual scaling
        SCALE = val;
    }

    detectBitmapScale(scales = [1]) {
        var scale = 1;

        scales = scales.slice(0);
        scales.sort();

        if((!FEATURES.IOS || FEATURES.IPHONE4) && scales.length > 1) {
            var ratio = window.devicePixelRatio || 1;

            ratio = 1;
            var sw = screen.width * ratio;
            var sh = screen.height * ratio;
            var w, h;

            if(this.size.width > this.size.height) {
                w = Math.max(sw, sh);
                h = Math.min(sw, sh);
            }
            else {
                w = Math.min(sw, sh);
                h = Math.max(sw, sh);
            }

            var test = [];
            for(var sc of scales) {
                test.push({
                    scale: sc,
                    coef: ((this.size.width * sc) / sw) * ((this.size.height * sc) / sh)
                });
            }

            var min = Number.MAX_VALUE;
            scale = scales[0];

            for(sc of test) {
                var diff = Math.abs(sc.coef - 1);
                if(diff < min) {
                    min = diff;
                    scale = sc.scale;
                }
            }
        }
        else scale = scales.pop();

        this.bitmapScale = scale;
        return scale;
    }

    addMobileListeners() {
        this._handleWindowVisibility();
        this._mobileHideAdressBar();

        window.addEventListener("orientationchange", () => {
            setTimeout(() => this.fitLayout(true), 1000);
        });
    }

    _handleWindowVisibility() {
        let props = {hidden: null, visibilityChange: null};
        if (undefined !== document.hidden) {
            props.hidden = "hidden";
            props.visibilityChange = "visibilitychange";
        }
        else if (undefined !== document.mozHidden) {
            props.hidden = "mozHidden";
            props.visibilityChange = "mozvisibilitychange";
        }
        else if (undefined !== document.msHidden) {
            props.hidden = "msHidden";
            props.visibilityChange = "msvisibilitychange";
        }
        else if (undefined !== document.webkitHidden) {
            props.hidden = "webkitHidden";
            props.visibilityChange = "webkitvisibilitychange";
        }

        if (props.visibilityChange) {
            document.addEventListener(props.visibilityChange, () => {

                WINDOW_IS_HIDDEN = document[props.hidden];

                if (WINDOW_IS_HIDDEN) {
                    /**
                     * Текущее окно потеряло фокус
                     * @event module:layout.DOMLayout#hidewindow
                     */
                    this.emit("hidewindow");
                }
                else {
                    /**
                     * Текущее окно получило фокус
                     * @event module:layout.DOMLayout#showwindow
                     */
                    this.emit("showwindow");
                }
            }, false);
        }
    }

    _mobileHideAdressBar() {
        if (!FEATURES.PLAY_FREE_BROWSER) {
            bindEvent(window, "scroll", () => {
                setTimeout(mobileHideAddressBar, 300);
            });
        }
        setTimeout(mobileHideAddressBar, 500);
    }

    addLayers(...names) {
        for (let name of names) {
            this.addLayer(name);
        }
    }

    addLayer(name) {
        let node = this.container.appendChild(document.createElement('div'));
        node.className = `p2m-layout-layer p2m-layer-${name}`;
        Object.assign(node.style, {
            position: 'absolute',
            left: '0px', right: '0px', top: '0px', bottom: '0px'
        });
        return node;
    }

    getLayer(name) {
        return this.container.querySelector(`.p2m-layer-${name}`);
    }

    addScreen() {
        let wrapper = this.container.querySelector('.p2m-layer-screens');
        let screen = CanvasLayer.create(wrapper);
        this.screens.push(screen);
        return screen;
    }

    getScreen(n = 0) {
        return this.screens[n];
    }

    initP2L({image = P2L, color = 'rgba(255, 0, 0, 1)', css = {}} = {}) {
        let p2l = this.container.querySelector('.p2m-layer-p2l');
        if (!p2l) return;
        Object.assign(p2l.style, {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            backgroundSize: '30%',
            backgroundImage: `url('${image}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center'
        });
        Object.assign(p2l.style, css || {});
    }

    /**
     * @description Определение размеров доступного пространства
     * @returns {Object} {"width": width, "height": height}
     */
    get windowRect() {
        let rect = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        if (this._domMarkElement) {
            rect.height = this._domMarkElement.offsetTop + this._domMarkElement.offsetHeight;
        }

        return rect;
    }

    /**
     * Текущая ориентация устройства
     * @returns {String}
     */
    get orientation() {
        var rect = FEATURES.MOBILE ? this.windowRect : this.size;
        return rect.width > rect.height ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT;
    }

    get autoFit() {
        return !!fitLayoutTimer;
    }

    set autoFit(val) {
        if (!!val != this.autoFit) {
            clearInterval(fitLayoutTimer);
            fitLayoutTimer = null;
            if (val) {
                fitLayoutTimer = setInterval(()=>this.fitLayout(), 500);
            }
        }
    }

    get viewport() {
        if (staticWindowRect) {
            return staticWindowRect;
        }
        
        let parent = this.container && this.container.parentNode;
        if (parent) {
            return (this.container === document.body || parent === document.body)
                ? this.windowRect
                : { width: parent.clientWidth, height: parent.clientHeight };
        }
        return this.windowRect;
    }

    set viewport(rect) {
        staticWindowRect = rect;
    }

    get p2l() {
        let p2l = this.getLayer('p2l');
        return p2l && p2l.style.display !== 'none';
    }

    set p2l(val) {
        let p2l = this.getLayer('p2l');
        if (p2l) {
            p2l.style.display = val ? 'block' : 'none';
        }
    }

    showPreloader() {
        this.getLayer('screens').style.display = 'none';
        this.getLayer('preloader').style.display = 'block';
    }

    showScreens() {
        this.getLayer('preloader').style.display = 'none';
        this.getLayer('screens').style.display = 'block';
    }

    // returns rect which layout should be fitted in (with margins)
    _getLayoutRect(viewport) {
        let margin = (isNaN(this.margin) ? (this.margin || [0]) : [this.margin]);
        let [marginTop, marginRight=marginTop, marginBottom=marginTop, marginLeft=marginRight] = margin;
        let layoutRect = {
            left: marginLeft,
            top: marginTop,
            width: viewport.width - (marginLeft + marginRight),
            height: viewport.height - (marginTop + marginBottom)
        };
        return layoutRect;
    }

    fitLayout(force = false) {

        let viewport = this.viewport;

        // viewport size not changed
        if (!force && this._lastViewport.width === viewport.width && this._lastViewport.height === viewport.height) {
            return false;
        }

        Object.assign(this._lastViewport, viewport);

        let layoutRect = this._getLayoutRect(viewport);
        this.checkOrientation(viewport);

        this.scale = Math.min(layoutRect.width / this.size.width, layoutRect.height / this.size.height);

        let appRect = {
            left: 0,
            top: 0,
            width: Math.floor(this.size.width * this.scale),
            height: Math.floor(this.size.height * this.scale)
        };

        let {horizontal: alignHorizontal, vertical: alignVertical} = this.align;

        if (alignHorizontal == ALIGN.LEFT) alignHorizontal = 0;
        if (alignHorizontal == ALIGN.CENTER) alignHorizontal = 0.5;
        if (alignHorizontal == ALIGN.RIGHT) alignHorizontal = 1;
        appRect.left = !alignHorizontal || isNaN(alignHorizontal) ? 0 : (layoutRect.width - appRect.width) * alignHorizontal;

        if (alignVertical == VALIGN.TOP) alignVertical = 0;
        if (alignVertical == VALIGN.MIDDLE) alignVertical = 0.5;
        if (alignVertical == VALIGN.BOTTOM) alignVertical = 1;
        appRect.top = !alignVertical || isNaN(alignVertical) ? 0 : (layoutRect.height - appRect.height) * alignVertical;

        let screensRect = {
            width: this.size.width,
            height: this.size.height
        };

        if(this.autoFill) {
            if(appRect.width < layoutRect.width) {
                screensRect.width = Math.floor(screensRect.width * layoutRect.width / appRect.width);
            }

            if(appRect.height < layoutRect.height) {
                screensRect.height = Math.floor(screensRect.height * layoutRect.height / appRect.height);
            }

            appRect.left = 0;
            appRect.top = 0;
            appRect.width = layoutRect.width;
            appRect.height = layoutRect.height;
        }

        Object.assign(this.container.style, {
            left: layoutRect.left + "px",
            top: layoutRect.top + "px",
            width: layoutRect.width + "px",
            height: layoutRect.height + "px"
        });

        let screens = this.getLayer('screens').querySelectorAll('.p2m-screen');
        for (let node of screens) {
            Object.assign(node.style, {
                left: appRect.left + "px",
                top: appRect.top + "px",
                width: appRect.width + "px",
                height: appRect.height + "px"
            });
        }

        this.calculatedSize = {
            width: appRect.width,
            height: appRect.height,
            screenWidth: screensRect.width,
            screenHeight: screensRect.height,
            scale: SCALE
        };

        /**
         * Изменение размеров окна
         * @event module:layout.DOMLayout#fitlayout
         * @property {number} width ширина
         * @property {number} height высота
         * @property {number} screenWidth ширина экрана
         * @property {number} screenHeight высота экрана
         * @property {number} scale масштаб
         */
        this.emit('fitlayout', this.calculatedSize);
    }

    /**
     * Проверка на правильную ориентацию устройства
     * @return {boolean} TRUE если ориентация неправильная
     */
    checkOrientation(viewport = this.viewport) {

        if (!FEATURES.MOBILE) return false;

        let viewportAspectRatio = viewport.width / viewport.height,
            appAspectRatio = this.size.width / this.size.height;

        if ((Infinity === viewportAspectRatio) || (Infinity === appAspectRatio)) return false; // no size
        if ((1 === viewportAspectRatio) || (1 === appAspectRatio)) return false; // square viewport or app always OK

        let current = (viewportAspectRatio > 1);
        if (this._lastOrientation === current) {
            return false;
        }

        this._lastOrientation = current;

        let wrong = ((appAspectRatio > 1) ^ current);

        if(!this.noCheckOrientation) {
            this.p2l = wrong; // TODO: configurable behavior - automatic P2L screen

            if (wrong) {
                /**
                 * Возник диалог неверного поворота экрана на мобильном
                 * @event module:layout.DOMLayout#lockscreen
                 */
                this.emit("lockscreen");
            }
            else {
                /**
                 * Спрятался диалог неверного поворота экрана на мобильном
                 * @event module:layout.DOMLayout#unlockscreen
                 */
                this.emit("unlockscreen");
            }
        }
        else {
            this.p2l = false;
            wrong = false;
        }

        /**
         * Смена ориентации мобильного устройства
         * @event module:layout.DOMLayout#orientationchange
         * @param {boolean} locked залочен ли экран диалогом неверного поворота
         */
        this.emit('orientationchange', {locked: wrong, orientation: viewportAspectRatio > 1 ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT});

        return wrong;

    }

    refreshScreen(n) {
        this.getScreen(n).refresh = true;
    }

    tick(delta) {
        for (let scr of this.screens) {
            scr.tick(delta);
        }
    }
}

export { ORIENTATION };
export default DOMLayout;